import { useState } from "react";
import FormattedText from "../../FormattedText/FormattedText";
import Icon, { IconData } from "../Icon";
import {
  Container,
  IconContainer,
  InfoButton,
  TextContainer,
  TitleText,
  TooltipContainer,
  TooltipText,
} from "./PersuasionComponent.style";

// Optimized SVG icons
const DEFAULT_MONEY_ICON = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="10" cy="10" r="8" fill="url(#paint0_linear)" stroke="#3B385E" stroke-width="0.33"/>
  <path d="M12.58 8.56c-.03-.03-.07-.04-.12-.04h-.88c-.05-.26-.16-.5-.33-.71h1.2c.04 0 .08-.02.11-.05.03-.03.05-.07.05-.11v-.5c0-.04-.02-.08-.05-.11-.03-.03-.07-.04-.11-.04H8.17c-.04 0-.08.02-.11.05-.03.03-.05.07-.05.11v.65c0 .04.02.08.05.11.03.03.07.04.11.04h.75c.72 0 1.18.18 1.38.55H8.17c-.04 0-.08.02-.11.05-.03.03-.05.07-.05.11v.5c0 .04.02.08.05.11.03.03.07.04.11.04h2.2c-.08.27-.25.47-.53.61-.28.14-.64.21-1.09.21h-.58c-.04 0-.08.02-.11.05-.03.03-.05.07-.05.11v.62c0 .04.02.08.05.11.66.67 1.51 1.6 2.56 2.8.03.04.07.06.13.06h1c.07 0 .12-.03.15-.09.03-.06.03-.11-.02-.16-1-.17-1.79-1.05-2.36-1.63.58-.07 1.05-.25 1.42-.54.36-.29.58-.67.66-1.14h.86c.04 0 .08-.02.11-.05.03-.03.05-.07.05-.11v-.5c0-.04-.02-.08-.05-.11z" fill="#3B385E"/>
  <defs>
    <linearGradient id="paint0_linear" x1="5.19" y1="-1.63" x2="-0.95" y2="17.58" gradientUnits="userSpaceOnUse">
      <stop stop-color="#F8E24E"/>
      <stop offset="1" stop-color="#EEC42F"/>
    </linearGradient>
  </defs>
</svg>`;

const INFO_ICON = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="8" cy="8" r="6.4" stroke="#757575"/>
  <path d="M8.67 7.32v4.41c0 .37-.3.67-.67.67s-.67-.3-.67-.67V7.32c0-.37.3-.67.67-.67s.67.3.67.67z" fill="#757575"/>
  <circle cx="8" cy="5.17" r="0.87" fill="#757575"/>
</svg>`;

interface TextProps {
  text?: {
    value?: string;
    styles?: Record<string, string | number>;
  };
}

interface PopoverProps {
  description?: TextProps;
}

interface PersuasionComponentProps {
  icon?: IconData;
  title?: TextProps;
  popover?: PopoverProps;
}

const PersuasionComponent = ({
  icon,
  title,
  popover,
}: PersuasionComponentProps) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <Container>
      <IconContainer>
        <Icon
          icon={icon || { svg: DEFAULT_MONEY_ICON }}
          alt="Persuasion icon"
        />
      </IconContainer>

      <TextContainer>
        {title?.text?.value && (
          <TitleText>
            <FormattedText value={title.text.value} />
          </TitleText>
        )}

        {popover?.description && (
          <InfoButton
            type="button"
            onClick={() => setShowTooltip(!showTooltip)}
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
          >
            <Icon icon={{ svg: INFO_ICON }} alt="Info icon" />
            {showTooltip && (
              <TooltipContainer>
                <TooltipText>
                  <FormattedText value={popover.description} />
                </TooltipText>
              </TooltipContainer>
            )}
          </InfoButton>
        )}
      </TextContainer>
    </Container>
  );
};

export default PersuasionComponent;
